// @flow
import styled from "styled-components"
import { Relative } from "componentsStyled/Layout/Position"

export const SearchAutocompleteWrap = styled(Relative)`
  flex-grow: 1;
  max-width: 42rem;
`



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/LoggedInNav/SearchAutocomplete/styled.js